module.exports = __webpack_public_path__ + "static/media/WP-Snippet-01-small.530fce51.mp4";